import { styled } from 'baseui';
export const TITLE_LEFT_MARGIN = 16;
export const SWATCH_CIRCLE_SIZE = 10;
export const SidePanelContainer = styled<'div', {
  $customWidth?: string;
}>('div', ({
  $customWidth
}) => ({
  width: $customWidth || '320px',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  transition: 'width 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
}));
export const SidePanelContainerM4 = styled<'div', {
  $customWidth?: string;
}>('div', ({
  $customWidth,
  $theme
}) => ({
  width: $customWidth || '320px',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  borderLeft: `2px solid ${$theme.colors.borderOpaque}`
}));
export const EmptyMessageContainer = styled('div', ({
  $theme: {
    sizing,
    colors
  }
}) => ({
  padding: `${sizing.scale400} ${sizing.scale500}`,
  color: colors.contentTertiary,
  fontStyle: 'italic'
}));
export const Title = styled('span', {
  marginLeft: `${TITLE_LEFT_MARGIN}px`,
  fontSize: '16px'
});
export const SelectableListItemContainer = styled<'div', {
  $isSelected: boolean;
  $isLast?: boolean;
  $isChild?: boolean;
}>('div', ({
  $theme: {
    colors,
    sizing,
    borders
  },
  $isSelected,
  $isChild
}) => ({
  border: $isSelected ? `${sizing.scale0} solid ${colors.borderSelected}` : 'none',
  backgroundColor: colors.backgroundPrimary,
  borderRadius: borders.radius200,
  borderLeft: $isSelected ? `${sizing.scale100} solid ${colors.accent}` : 'none',
  position: 'relative',
  color: colors.contentPrimary,
  display: 'flex',
  transition: 'background-color 0.2s, border 0.2s',
  padding: `${sizing.scale300} ${$isChild ? sizing.scale800 : sizing.scale500}`,
  ':hover': {
    cursor: 'pointer'
  }
}));
export const SwatchCircle = styled<'div', {
  $color: string;
}>('div', ({
  $color
}) => ({
  height: `${SWATCH_CIRCLE_SIZE}px`,
  width: `${SWATCH_CIRCLE_SIZE}px`,
  backgroundColor: $color,
  borderRadius: '50%',
  marginLeft: '4px'
}));
export const PanelContainer = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column'
}));
export const Separator = styled('hr', ({
  $theme
}) => ({
  width: $theme.sizing.scale200,
  cursor: 'ew-resize',
  backgroundColor: $theme.colors.backgroundSecondary,
  userSelect: 'none',
  margin: 0,
  border: 'none'
}));
export const ContextualPanelContainer = styled<'div', {
  $customWidth?: string;
}>('div', ({
  $customWidth
}) => ({
  width: $customWidth || '320px',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex'
}));